<template>
    <div class="list">
        <label for="list" class="form-label"><h5>用戶列表</h5></label>
        <table class="table table-hover" id="list">
            <colgroup>
                <col style="width: 5%;">
                <col style="width: 22%;">
                <col style="width: 30%;">
                <col style="width: 23%;">
                <col style="width: 20%;">
            </colgroup>
            <thead>
                <tr>
                    <th scope="col">id</th>
                    <th scope="col">姓名</th>
                    <th scope="col">職稱</th>
                    <th scope="col">公司</th>
                    <th scope="col"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="user in users" :key="user.id">
                    <th scope="row">{{ user.id }}</th>
                    <td>{{ user.name }}</td>
                    <td>{{ user.position }}</td>
                    <td>{{ user.company }}</td>
                    <td><button type="button" class="btn btn-sm" :class="user.alive == 1 ? 'btn-danger' : 'btn-success'" @click="alive(user.id, user.alive == 1 ? 0 : 1)">{{ user.alive == 1 ? '停用' : '啟用' }}</button></td>
                </tr>
            </tbody>
        </table>
        <!-- 分頁按鈕 -->
        <div v-if="totalPages > 1">
            <button type="button" class="btn btn-lg"
                :disabled="currentPage === 1" 
                @click="getList(currentPage - 1)">
                &laquo;
            </button>
            <span><b>{{ currentPage }}</b> / {{ totalPages }}</span>
            <button  type="button" class="btn btn-lg"
                :disabled="currentPage === totalPages" 
                @click="getList(currentPage + 1)">
                &raquo;
            </button>
        </div>
    </div>
</template>
<script setup>
import axios from 'axios';
import { onMounted, ref } from 'vue';

const users = ref([]);
const currentPage = ref(1);
const totalPages = ref(0);

const getList = async (page=1) => {
  try {
    const response = await axios.get(
      `https://baofengbooks.com/s_api/public/api/user-list?page=${page}`
    );
    users.value = response.data.data;
    currentPage.value = response.data.current_page;
    totalPages.value = response.data.last_page;
    console.log(response.data)
  } catch (error) {
    console.error(error.response || error);
    alert('用戶取得錯誤');
  }
};

const alive = async(id, status) => {
    try {
        const response = await axios.post(
            'https://baofengbooks.com/s_api/public/api/alive-account',
            {
                id: id,
                alive: status
            }
        );
        if(response.data) {
            alert('成功');
            getList();
        }
    } catch (error) {
        console.error(error.response || error);
        alert('失敗');
    }
};

onMounted(() => {
    getList(currentPage.value);
});
</script>
<style scoped>
  button{
    font-weight: 600;
  }
  h5{
    font-weight: 600;
  }
  #list{
    vertical-align: middle;
  }
  @media screen and (max-width:900px)  {
    .list{
        font-size: small;
    }
    .btn{
        width: 30px;
        font-size: 10px;
        padding: 2px;
    }
  }
</style>
  